// import node module libraries
import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Card, ListGroup, Container, Alert } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';

// import sub components
import HeaderBreadcrumb from '../HeaderBreadcrumb';
import ArticlesCategoryCard from './ArticlesCategoryCard';

// Import authentication components
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';

// Import Loading Animation
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

// import MDI icons
import Icon from '@mdi/react';
import { mdiArrowRight } from '@mdi/js';

const HelpCenterGuideCategory = () => {
	const guideInfo = useParams();
	const categoryslug = guideInfo.categoryslug;
	const title = guideInfo.title;

	const [GuidesResources, setGuidesResources] = useState([]);
	const [isLoadingGuidesResources, setIsLoadingGuidesResources] = useState(true);

	const breadcrumb = [
		{
			page: 'Help Center',
			link: '/marketing/help-center/'
		},
		{
			page: 'Guides & Resources',
			link: '/marketing/help-center/guide/'
		},
		{
			page: categoryslug,
			link: '#'
		}
	];

	const authHeader = useAuthHeader();
	// fetch data from api
	const options = {
		params: {

		},
		headers: {
			Authorization: authHeader,
			Accept: 'application/json'
		}
	};

	const getData = async () => {
		setIsLoadingGuidesResources(true);

		// Dynamische URL basierend auf der Umgebung
		const baseURL = process.env.REACT_APP_ENV === 'development'
			? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
			: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

		await axios.get(`${baseURL}/public/guides`, options)
			.then(response => {
				const responseData = response.data.data; // Extract the data from the response
				setGuidesResources(
					responseData
				);
				setIsLoadingGuidesResources(false);
			})
			.catch((error) => {
				setIsLoadingGuidesResources(false);
			});
	}

	useEffect(() => {
		getData();
	}, []);

	return (
		<Fragment>
			{/* header and breadcrumb */}
			<HeaderBreadcrumb title="Guides & Resources" breadcrumb={breadcrumb} />
			{/* articles category listing cards */}
			<section className="py-10">
				<Container>
					<Row>
						<Col md={{ offset: 2, span: 8 }} xs={12}>
							<Row>
								{isLoadingGuidesResources ? (
									<>
										{Array.from({ length: 6 }).map((_, idx) => (
											<Col lg={6} xs={12} key={idx}>
												<Card className="border mb-4">
													<Card.Body className="p-5">
														{/* category title and description  */}
														<div className="mb-5">
															<h2 className="fw-semi-bold"><Skeleton height="40px" /></h2>
															<Skeleton height="15px" count={2} />
														</div>
														{/* articles list  */}
														<ListGroup as="ul" bsPrefix="list-unstyled">
															<ListGroup.Item as="li" className="mb-2" bsPrefix=" ">
																<Skeleton height="10px" count={6} />
															</ListGroup.Item>
														</ListGroup>
													</Card.Body>
													<Card.Footer>
														<Skeleton height="10px" count={1} />
													</Card.Footer>
												</Card>
											</Col>
										))}
									</>
								) : (
									GuidesResources.filter(function (dataSource) {
										return dataSource.guide_category_slug === categoryslug;
									}).map((item, index) => {
										return (
											<Col lg={12} xs={12} key={index}>
												<ArticlesCategoryCard item={item} />
											</Col>
										);
									})
								)}
							</Row>
						</Col>
					</Row>
				</Container>
			</section>
		</Fragment>
	);
};
export default HelpCenterGuideCategory;
